<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item ">
    <h1>მზის პანელების პრიორიტეტულობა ბიზნესისა და ქვეყნისთვის</h1>
    <h6>თებერვალი 2021</h6>
    <br />
    <h1 style="text-align: center"></h1>

    <p>
      ეკომეგობრულია, დამოუკიდებელს გხდის, ეკონომიურობაში გეხმარება და შენზე გრძელვადიანად ზრუნავს. თუ ამ აღწერის დროს
      სამაგალითო ადამიანი წარმოიდგინე, გეტყვით, რომ საუბარი მზის პანელებზეა და კი, მისი უპირატესობების ჩამოთვლა
      დაუსრულებლად შეგვიძლია.
    </p>
    <p>
      კაცობრიობისთვის მზის პანელების მნიშვნელობა რომ ცხადად დავინახოთ, საკმარისია ერთმანეთს ტრადიციული რესურსები და მზის
      ენერგია შევადაროთ. ენერგიის ეს სახე იმ წყაროებისგან განსხვავებით, რომლებსაც ჩვენ მოვიხმართ, ამოუწურავია. მზის
      სხივს არ სჭირდება მოპოვება, ტრანსპორტირება, არ გააჩნია წონა, არც ხმაურობს და დედამიწისთვის მავნე ნარჩენებსაც არ
      წარმოქმნის, რასაც ვერ ვიტყვით ენერგიის მოპოვების სხვა გზებზე. სწორედ ამიტომაა ის <b>ეკომეგობრული</b>.
    </p>

    <img src="../../../../assets/blog/solar/img1.jpg" alt="" />

    <p>
      პირველი მიზეზი, რატომაც მსოფლიო მასშტაბით ამ ტიპის ენერგიის მზის პანელებით ათვისება სულ უფრო და უფრო აქტუალური
      ხდება, ამოუწურვადობა და ეკოლოგიური კატასტროფების პრევენციაა, შემდგომში კი — მისი <b>ბიუჯეტურობა</b>.
    </p>
    <p>
      თუ გავითვალისწინებთ NASA­-ს კვლევის მონაცემებს, მზით სავსე თვეებში, კერძოდ, მაისიდან ოქტომბრამ­დე, საქართველოში,
      წყლის გასაცხელებლად საჭირო ენერგიას 100%-ით გამოიმუშავებ, მარტში, აპრილსა და ოქტომბერში მიიღებ საჭირო სითბოს
      ნახევარს, ნოემბრიდან თებერვლამდე კი – 20­-30%­-ს. გამოდის, რომ ჩვენს ქვეყნაში არ არსებობს ისეთი პერიოდი, რომლის
      დროსაც მზის პანელებით გარკვეული რაოდენობის ენერგიას მაინც არ დააგროვებ.
    </p>
    <p>
      მართლაც, თუ ზემოთმოყვანილ კვლევას და იმ ფაქტს გავითვალისწინებთ, რომ საქართველოში წელიწადის 250-280 დღე მზიანია,
      თამამად შეიძლება ვთქვათ, რომ <b>მზის ენერგიის ათვისება ბიზნესსექტორისთვის უდიდესი შესაძლებლობაა.</b>
    </p>

    <img src="../../../../assets/blog/solar/img2.jpg" alt="" />

    <p>
      ბიზნესი, რომელიც მზის პანელებით სარგებლობს ან მათ აწარმოებს, ქვეყნისთვის ქმნის შესაძლებლობას ავითვისოთ ენერგიის
      ამოუწურავი რესურსი, გარდავქმნათ ის ელექტრო ან თბოენერგიად, დამატებით კი, ეკოლოგიაზეც ვიზრუნოთ. ბიზნესის მხრიდან
      სოლარული ფერმისთვის ერთჯერადად გამოყოფილი თანხა სამომავლოდ დიდი შემოსავლის გამომუშავებასა და დაზოგილი ფინანსების
      სხვა ინვესტიციებისკენ მიმართვის საშუალებაა, რაც პირდაპირ კავშირშია ქვეყნის ეკონომიკურ სტაბილურობასთან.
    </p>
    <p>ბიზნესჭრილში, მზის პანელები სხვადასხვა მიზნობრიობით შეგვიძლია გამოვიყენოთ, მაგალითად:</p>
    <p>
      <strong>სამრეწველო საწარმოებისთვის</strong><br /><br />
      სამრეწველო საწარმოს ტერიტორიაზე მზის პანელების დაყენებამ გათბობის ყოველთვიური მომსახურების ხარჯები შეიძლება
      70­-80%-მდე შეგიმციროს. ერთჯერადად გაღებული ხარჯით ბიზნესს 25+ წლის განმავლობაში ელექტრო და თბოენერგიის ხარჯებს
      მნიშვნელოვნად შეუმცირებ.
    </p>
    <img src="../../../../assets/blog/solar/img3.jpg" alt="" />

    <p>
      <strong>სასტუმროებისთვის</strong><br /><br />

      გამოცდილება აჩვენებს, რომ მზის პანელების დაყენებისთვის ერთ-ერთი ყველაზე ხელსაყრელი ობიექტი — სასტუმროებია.
      მართლაც, სასტუმრო იმ ბიზნესებს მიეკუთვნება, სადაც დიდი რაოდენობით ელექტრო და თბოენერგია იხარჯება.
    </p>
    <p>
      <strong>კვების ობიექტებისთვის</strong><br /><br />

      რესტორნებისა და კაფე-ბარების მეპატრონეებისთვის ნაცნობია იმ ხარჯების ოდენობა, რაც ცხელი წყლით მომარაგებას,
      გათბობასა და განათებას სჭირდება. გარდა იმისა, რომ მზის პანელები ამ ხარჯს ამცირებს, მათი დახმარებით, უკვე აღარ
      იქნები დამოკიდებული გაზისა თუ ელექტროენერგიის ტარიფის ზრდაზე.
    </p>
    <img src="../../../../assets/blog/solar/img4.jpg" alt="" />

    <p>
      <strong>მეურნეობებისთვის</strong><br /><br />

      სოფლის მეურნეობის სექტორისთვის ეკოლოგიურად სუფთა ენერგეტიკული წყარო კიდევ უფრო მიმზიდველად ჟღერს. ფერმებსა თუ სხვა
      სამეურნეო ტერიტორიებზე მზის პანელების დამონტაჟებას სოფლის მეურნეობაში ჩართული სულ უფრო და უფრო მეტი პირი
      მიმართავს.
    </p>
    <p>
      <strong>მზის ფერმებისთვის</strong><br /><br />

      ერთია მზის ენერგიის გამოყენება ბიზნესისთვის, მეორე კი — პანელების ბიზნესიდეად ქცევა. მას შემდეგ, რაც კანონი
      შეიცვალა და ელექტროსადგურის დადგმული სიმძლავრე 100 კილოვატიდან 500 კილოვატამდე გაიზარდა, ადგილობრივი ბაზრისთვის
      მზის ენერგიაში ინვესტიცია უფრო მიმზიდველი გახდა. ამას ადასტურებს ის ფაქტიც, რომ 2020 წლიდან საქართველოში
      ელექტროსადგურების რაოდენობა 40%-ით გაიზარდა.
    </p>
    <img src="../../../../assets/blog/solar/img5.jpg" alt="" />
  </div>
  <div class="container-fluid m-0 p-0">
    <div class="solar-accent">
      <div class="container blog-item">
        <div class="row">
          <div class="col-12">
            <p style="font-size: 28px;font-weight: bolder;padding-top: 40px;">
              მზის პანელების ლიზინგით შეძენის შემთხვევაში სოფლის მეურნეობის პროექტებს სუბსიდირებას სოფლის განვითარების
              სააგენტო/Rda უწევს, ხოლო საწარმოებს, სასტუმროებსა თუ სხვა პროექტებს “აწარმოე საქართველო”. აღნიშნული
              სუბსიდირების შემთხვევაში, ლიზინგის ყოველთვიური გადასახადი მნიშვნელოვნად მცირდება, რომ არაფერი ვთქვათ,
              სამომავლოდ შემცირებულ ელექტრო და თბოენერგიის ხარჯებზე.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container blog-item ">
    <p>
      დამატებით, 2020 წელს ლუქსემბურგის ფონდს, “Green For Growth Fund” (GGF)-სა და თიბისი ლიზინგს შორის
      <b>16,4 მილიონი ლარის</b> მოცულობის სასესხო ხელშეკრულება გაფორმდა, რომლის მიზანი სწორედ ენერგოეფექტური პროექტების
      დაფინანსების ხელშეწყობაა, მათ შორის მზის პანელებიც მოიაზრება.
    </p>
    <p>
      ეს დაფინანსება საშუალებას მისცემს ბიზნესებს განახორციელონ ენერგოეფექტური ინვესტიციები და წვლილი შეიტანონ ქვეყნის
      ეკონომიკის მწვანე აღდგენაში.
    </p>
    <p>
      აღსანიშნავია, რომ საქართველოს ახალი ენერგოპოლიტიკის თანახმად, 2030 წლისთვის, ქვეყნის ენერგიის 35% განახლებადი
      ენერგიის წყაროებიდან იქნება მიღებული, რაც დროთა განმავლობაში ქვეყანას ეკოლოგიურ და ეკონომიკურ სტაბილურობას
      მოუტანს.
    </p>

    <br />
    <div class="blog-author"><span>ავტორი: ნინჩო ბალანჩივაძე</span></div>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item ">
    <h1>Priority of Solar Panels for Business and the Country</h1>
    <h6>February 2021</h6>
    <br />
    <h1 style="text-align: center"></h1>

    <p>
      Eco-friendly, makes you independent, helps with cost-efficiency, and takes care of you in the long term. If you
      imagined an ideal person while reading this description, let me tell you that we're talking about solar panels,
      and yes, we could go on listing their advantages indefinitely.
    </p>
    <p>
      To clearly understand the significance of solar panels for humanity, it is enough to compare traditional resources
      with solar energy. Unlike the sources we use, this form of energy is inexhaustible. Sunlight doesn’t require
      extraction, transportation, has no weight, makes no noise, and doesn’t produce harmful waste for the Earth, which
      can’t be said about other methods of energy production. This is why solar energy is
      <b>eco-friendly</b>.
    </p>

    <img src="../../../../assets/blog/solar/img1.jpg" alt="" />

    <p>
      The first reason why the use of solar panels is becoming more and more relevant worldwide is inexhaustibility and
      the prevention of ecological disasters, followed by its
      <b>cost-efficiency</b>.
    </p>
    <p>
      If we take into account NASA’s research data, during the sun-filled months, from May to October, you can generate
      100% of the energy needed for water heating through solar panels in Georgia. In March, April, and October, you
      will receive about half of the necessary warmth, and from November to February, about 20-30%. Therefore, there is
      no period in Georgia when you can’t accumulate some amount of energy using solar panels.
    </p>
    <p>
      Indeed, considering the above research and the fact that Georgia has 250-280 sunny days per year, we can
      confidently say that the use of solar energy is an
      <b>enormous opportunity for the business sector.</b>
    </p>

    <img src="../../../../assets/blog/solar/img2.jpg" alt="" />

    <p>
      A business that uses or produces solar panels creates the opportunity for the country to harness an inexhaustible
      energy source, convert it into electricity or thermal energy, and also care for the environment. A one-time
      investment in a solar farm will allow businesses to significantly reduce future energy costs and direct the saved
      finances to other investments, directly contributing to the country's economic stability.
    </p>
    <p>
      Solar panels can be used in various business contexts, such as:
    </p>
    <p>
      <strong>Industrial Enterprises</strong><br /><br />
      Installing solar panels on industrial premises can reduce heating costs by 70-80%. A one-time investment will
      significantly lower electricity and heating costs for over 25+ years.
    </p>
    <img src="../../../../assets/blog/solar/img3.jpg" alt="" />

    <p>
      <strong>Hotels</strong><br /><br />
      Experience shows that hotels are among the most favorable places to install solar panels. Hotels, being
      energy-intensive businesses, consume large amounts of electricity and thermal energy, making them ideal candidates
      for solar panel installation.
    </p>
    <p>
      <strong>Restaurants and Cafés</strong><br /><br />
      For restaurant and café owners, the high costs of providing hot water, heating, and lighting are well known. Solar
      panels not only reduce this cost but also make you independent of the increasing gas or electricity tariffs.
    </p>
    <img src="../../../../assets/blog/solar/img4.jpg" alt="" />

    <p>
      <strong>Agricultural Sector</strong><br /><br />
      The agricultural sector finds eco-friendly energy sources even more attractive. More and more farmers are turning
      to solar panel installation on their lands and agricultural areas.
    </p>
    <p>
      <strong>Solar Farms</strong><br /><br />
      Using solar energy for business is one thing, but transforming it into a solar farm is another. Since the law was
      amended and the capacity of electric stations increased from 100 kW to 500 kW, solar energy investments have
      become more attractive. This is confirmed by the fact that, since 2020, the number of solar power plants in
      Georgia has increased by 40%.
    </p>
    <img src="../../../../assets/blog/solar/img5.jpg" alt="" />
  </div>
  <div class="container-fluid m-0 p-0">
    <div class="solar-accent">
      <div class="container blog-item">
        <div class="row">
          <div class="col-12">
            <p style="font-size: 28px;font-weight: bolder;padding-top: 40px;">
              When purchasing solar panels through leasing, agricultural projects receive subsidies from the Rural
              Development Agency (RDA), and businesses, hotels, or other projects can access subsidies from "Produce in
              Georgia". These subsidies significantly reduce monthly leasing payments, not to mention the long-term
              savings on electricity and heating costs.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container blog-item ">
    <p>
      Additionally, in 2020, a loan agreement worth <b>16.4 million GEL </b>
      was signed between the Green for Growth Fund (GGF) and TBC Leasing, aimed at financing energy-efficient projects,
      including solar panels.
    </p>
    <p>
      This funding will help businesses invest in energy-efficient solutions and contribute to the country’s green
      economic recovery.
    </p>
    <p>
      It is important to note that, according to Georgia’s new energy policy, by 2030, 35% of the country's energy will
      come from renewable sources, which will gradually lead to both ecological and economic stability for the country.
    </p>

    <br />
    <div class="blog-author"><span>Author: Nincho Balanchivadze</span></div>
  </div>
</ng-container>
